module.exports = __webpack_public_path__ + "static/media/stairs.7b1ff811.jpg";